import { FillInputByLabelInstruction } from '../FillInputByLabelInstruction'

export class StreetInstruction extends FillInputByLabelInstruction {
  constructor ({ label, waitForNoLoaders, value }) {
    super({
      name: 'Street',
      label,
      waitForNoLoaders,
      value

    })
  }

  setDefaultValue (params) {
    this.value = this.retrieveStreetFromAddress(params.addressInformation.userAddress)
  }

  retrieveStreetFromAddress (address) {
    const words = address.split(' ')
    return words.slice(0, -1).join(' ')
  }
}
